<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
           
            
               
            <el-row :gutter="20">
                <el-col :md="10" :lg="7">
                    <el-input placeholder="手机号" size="small" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                
            </el-row>
            
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name" :name="item.activeName">
                    <el-table :data="ItemsList" style="width: 100%" @selection-change="handleSelectionChange"  v-loading="loading">
                        
                        <el-table-column  width="70"></el-table-column>
                        <el-table-column prop="user_id" label="用户id" width="150"></el-table-column>
                        <el-table-column prop="username" label="用户姓名" width="120" >
                            
                        </el-table-column>
                        
                        <el-table-column prop="mobile" label="手机号" width="230" ></el-table-column>
                        <el-table-column prop="black_status" label="状态" width="250">
                            <template slot-scope="scope">
                            <el-tag>{{scope.row.black_status}}</el-tag>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="content-center content-top-padded">
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page.sync="params.page"
                                :page-sizes="[10,20,50]"
                                :total="total_count"
                                :page-size="params.pageSize">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
       
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { getDistributorList } from '../../api/marketing'
    import {
        getLiveBlack as getList,
    } from '../../api/live'
    import sideBar from '@/components/element/sideBar'
    export default {
        components: {
          sideBar
        },
        props: {
          distributorId: {
            type: String,
            default: ''
          },
          isLoad: {
            type: Boolean,
            default: false
          }
        },
        data () {
            return {
                
                loading:true,
                
                tabList: [
                    {name: "列表", value: null, activeName: 'first'},
                    // {name: "已领取完列表", value: 'true', activeName: 'second'},
                ],
                activeName: 'first',
                ItemsList: [],
                params: {
                    page: 1,
                    pageSize: 20,
                    mobile:'',
                   
                },
                total_count:0,
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            handleSelectionChange (val) {
                let item_id = []
                for (let i in val) {
                    item_id.push(val[i].live_id)
                }
                this.item_id = item_id
            },
            handleSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            
            handleGoodsDialogCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            handleGoodsDialogSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            
            
            search () {
                this.params.page = 1
                this.getList()
            },
            getList () {
                this.userloading = true
                this.loading = true
                getList(this.params).then(response => {
                    console.log(response.data.data)
                    this.ItemsList = response.data.data.list
                    this.total_count = response.data.data.total_count
                    this.loading = false
                })
            },
            
            

        },
        mounted () {
           
            this.params = this.$route.query
            this.getList()
            
        },
        watch: {
            $route(){
                this.getList()
            }
        }
    }

</script>
<style>
    .goods-popover-img{
        margin-top: 5px;
        margin-bottom: 5px;
        background:#000;
        border:1px solid #fff;
        border-width:5px 5px 5px 5px;
        box-shadow:1px 1px 5px #333;
        -webkit-box-shadow:1px 1px 5px #333;
        -moz-box-shadow:1px 1px 5px #333;
    }
</style>



// WEBPACK FOOTER //
// black.vue?ab94b98c